import {observer} from "mobx-react";
import React from "react";
import {useNavigate} from "react-router-dom";

import {formatToUtc} from "../../../utils/format-to-utc";
import {AddButton} from "../../atoms/buttons/buttons";
import {Td, Tr} from "../../atoms/tables/table";
import {AdminBreadcrumb} from "../../organisms/admin-breadcrumb/admin-breadcrumb";
import {TableLayout} from "../../organisms/table-layout/table-layout";
import {AppLayout} from "../../templates/app-layout/app-layout";
import {CategoryGroupPageStore} from "./category-group-page-store";

const colums = [
    {
        label: "カテゴリグループ名",
        required: false,
    },
    {
        label: "識別子（Sllug）",
        width: 185,
        required: false,
    },
    {
        label: "作成日",
        width: 220,
        required: false,
    },
];

export const CategoryGroupPage: React.FC<{pageStore: CategoryGroupPageStore}> = observer(
    (props) => {
        const navigate = useNavigate();
        return (
            <AppLayout
                breadcrumb={
                    <AdminBreadcrumb factory={(builder) => builder.categoryGroups().build()} />
                }
                buttons={
                    <AddButton
                        onClick={() => {
                            navigate(`/admin/${props.pageStore.mediaId}/category-groups/create`);
                        }}
                    >
                        作成
                    </AddButton>
                }
            >
                <TableLayout areaLabel="カテゴリグループ一覧" columns={colums}>
                    {props.pageStore.categoryGroups.map(
                        ({label, slug, createdAt, categoryGroupId}) => (
                            <Tr
                                onClick={() =>
                                    navigate(
                                        `/admin/${props.pageStore.mediaId}/category-groups/${categoryGroupId}`,
                                    )
                                }
                                key={categoryGroupId}
                                style={{cursor: "pointer"}}
                            >
                                <Td>{label}</Td>
                                <Td>{slug}</Td>
                                <Td>{formatToUtc(createdAt)}</Td>
                            </Tr>
                        ),
                    )}
                </TableLayout>
            </AppLayout>
        );
    },
);
